import { useEffect, useState } from "react";
import client from "@/lib/api";

export const DEFAULT_DEALER_HOST_SUFFIX = "skoda-auto.de";

/**
 * Reads the `dealer_host_suffix` global setting (System Administrator only —
 * see settings/DealerHostSuffixCard.jsx) — the domain every dealer site
 * lives under, e.g. "skoda-auto.de" in "https://www-eins.skoda-auto.de".
 * Readable by every authenticated user (dealer users see it on their own
 * dealership page), falling back to DEFAULT_DEALER_HOST_SUFFIX while
 * loading or if unset, matching the backend's own fallback.
 */
export function useDealerHostSuffix() {
  const [hostSuffix, setHostSuffix] = useState(DEFAULT_DEALER_HOST_SUFFIX);

  useEffect(() => {
    let cancelled = false;
    client.get(`/settings/dealer_host_suffix`).then(({ data }) => {
      if (!cancelled && data?.value) setHostSuffix(data.value);
    }).catch((err) => {
      console.debug("Could not read dealer_host_suffix:", err);
    });
    return () => {
      cancelled = true;
    };
  }, []);

  return hostSuffix;
}
